/**
 * Product image carousel — Slick (Natrava-style).
 * Init Slick on .product-image-carousel.slick-slider; reinit after variant/section update.
 */
(function () {
  function getSlickOptions($wrapper) {
    return {
      arrows: true,
      dots: false,
      fade: true,
      infinite: true,
      speed: 700,
      swipe: true,
      prevArrow: $wrapper.find('.slick-prev'),
      nextArrow: $wrapper.find('.slick-next'),
    };
  }

  function initSlick(container) {
    if (!container) return;
    
    // Only initialize on mobile devices
    if (window.innerWidth >= 750) {
      return; // Desktop - don't initialize carousel
    }
    
    // Wait for jQuery and Slick to be available
    if (typeof jQuery === 'undefined' || !jQuery.fn.slick) {
      setTimeout(function() {
        initSlick(container);
      }, 100);
      return;
    }
    
    // Only initialize if mobile carousel is active (product--mobile-carousel class)
    const productEl = container.querySelector ? container.querySelector('.product') : null;
    if (!productEl || !productEl.classList.contains('product--mobile-carousel')) {
      return;
    }
    
    // Try to find wrapper in container or document
    let $wrapper = jQuery(container).find('.product-image-carousel-wrapper');
    if (!$wrapper.length) {
      // Fallback: search entire document
      $wrapper = jQuery('.product-image-carousel-wrapper');
    }
    if (!$wrapper.length) return;
    
    // Find the carousel element (with or without slick-slider class)
    const $el = $wrapper.find('.product-image-carousel');
    const $prevBtn = $wrapper.find('.slick-prev');
    const $nextBtn = $wrapper.find('.slick-next');
    
    if (!$el.length) return;
    
    // Check if we have multiple slides
    const slideCount = $el.find('.product-carousel-slide').length;
    if (slideCount <= 1) {
      // Single image - don't initialize Slick, but ensure it's visible
      return;
    }
    
    // Need both buttons for carousel
    if (!$prevBtn.length || !$nextBtn.length) return;
    
    // Destroy existing instance if any
    if ($el.hasClass('slick-initialized')) {
      try {
        $el.slick('unslick');
      } catch (e) {
        // Ignore errors when destroying
      }
    }
    
    // Initialize Slick - it will add slick-slider class automatically
    try {
      $el.slick(getSlickOptions($wrapper));
    } catch (e) {
      console.error('Slick initialization error:', e);
    }
  }

  function initAll() {
    const productInfo = document.querySelector('product-info[id^="MainProduct"]');
    if (!productInfo) return;
    initSlick(productInfo);
  }

  function registerProductInfoCallback() {
    const productInfo = document.querySelector('product-info[id^="MainProduct"]');
    if (!productInfo || !productInfo.addPostProcessCallback) return;
    productInfo.addPostProcessCallback(function (newNode) {
      initSlick(newNode);
    });
  }

  function startInit() {
    // Try multiple times to ensure scripts are loaded
    let attempts = 0;
    const maxAttempts = 50; // 5 seconds max
    
    function tryInit() {
      attempts++;
      if (typeof jQuery !== 'undefined' && jQuery.fn.slick) {
        initAll();
        registerProductInfoCallback();
      } else if (attempts < maxAttempts) {
        setTimeout(tryInit, 100);
      }
    }
    
    tryInit();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', startInit);
    window.addEventListener('load', startInit);
  } else {
    startInit();
  }

  document.addEventListener('shopify:section:load', function (e) {
    const section = e.target && e.target.querySelector ? e.target : (e.detail && e.detail.sectionId ? document.getElementById('shopify-section-' + e.detail.sectionId) : null);
    if (section && section.querySelector && section.querySelector('.product-image-carousel-wrapper')) initSlick(section);
  });
})();
